import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { createQuery } from '@shared/lib/query-helpers';

const runAttemptsSchema = z.object({
  data: z.object({
    attempts: z.object({
      items: z.array(
        z.object({
          jobId: z.string(),
          attempt: z.number(),
          jobName: z.string(),
          startedAt: z.string(),
          processedCount: z.number(),
          failedCount: z.number(),
        })
      ),
      total: z.number(),
      truncated: z.boolean(),
    }),
  }),
});

export function useSyncRunAttempts(runId: string, enabled: boolean, live: boolean) {
  return useQuery({
    ...createQuery({
      queryKey: ['sync-inventory', 'run-attempts', runId],
      path: `/api/sync/jobs/v2/sync-runs/${encodeURIComponent(runId)}`,
      schema: runAttemptsSchema,
      staleTime: 0,
    }),
    enabled,
    refetchInterval: enabled && live ? 10_000 : false,
  });
}
